var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5245 3.5166C10.5249 3.5166 7.27446 6.76702 7.27446 10.7666V14.2587C7.27446 14.9958 6.96029 16.1195 6.58571 16.7479L5.19612 19.0558C4.33821 20.4816 4.93029 22.0645 6.50112 22.5962C11.709 24.3362 17.3278 24.3362 22.5357 22.5962C23.9978 22.1129 24.6382 20.3849 23.8407 19.0558L22.4511 16.7479C22.0886 16.1195 21.7745 14.9958 21.7745 14.2587V10.7666C21.7745 6.7791 18.512 3.5166 14.5245 3.5166Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7594 3.86674C16.3848 3.75799 15.9982 3.6734 15.5994 3.62507C14.4394 3.48007 13.3277 3.56465 12.2886 3.86674C12.639 2.97257 13.509 2.34424 14.524 2.34424C15.539 2.34424 16.409 2.97257 16.7594 3.86674Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1494 23.0308C18.1494 25.0245 16.5182 26.6558 14.5244 26.6558C13.5336 26.6558 12.6152 26.2449 11.9627 25.5924C11.3102 24.9399 10.8994 24.0216 10.8994 23.0308",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo9);
export default __webpack_public_path__ + "static/media/logo9.326ae8c1a871fe34af6d78b500e562f7.svg";
export { ForwardRef as ReactComponent };